import { createRouter, createWebHistory } from "vue-router";
import store from "../store";

const routes = [
  {
    name: "guest",
    path: "/signin",
    component: () => import("../components/layouts/Guest.vue"),
    meta: {
      middleware: "guest",
    },
    children: [
      {
        path: "",
        name: "signin",
        component: () =>
          import(/*webpackChunck: "signIn" */ "../pages/SignInview.vue"),
        meta: {
          title: `Sign In`,
        },
      },
      {
        path: "",
        name: "forgotPassword",
        component: () =>
          import(/*webpackChunck: "home" */ "../pages/ForgotPassword.vue"),
        meta: {
          title: `Forgot Password`,
        },
      },
    ],
  },
  {
    name: "base",
    path: "/",
    component: () => import("../components/layouts/Default.vue"),
    meta: {
      middleware: "auth",
    },
    children: [
      {
        path: "dashboard",
        name: "home",
        component: () =>
          import(/* webpackChunkName: "home" */ "../pages/DashboardView.vue"),
        meta: {
          title: `Dashboard`,
        },
      },

      {
        path: "/subscriber",
        name: "subscriber",
        component: () =>
          import(
            /*webpackChunck: "subscriber" */ "../pages/SubscriberView.vue"
          ),
        meta: {
          title: `Subscriber List`,
        },
      },
      {
        path: "/subscriber-create",
        name: "createSubscriberProfile",
        component: () => import("../pages/CreateSubscriberProfile.vue"),
        meta: {
          title: `Create Subscriber`,
        },
      },
      {
        path: "/subscriber-update/:id",
        name: "editSubscribersProfile",
        component: () => import("../pages/EditSubscriberProfile.vue"),
        meta: {
          title: `Edit Subscriber`,
        },
      },

      {
        path: "/package",
        name: "package",
        component: () =>
          import(/*webpackChunck: "package" */ "../pages/PackageView.vue"),
        meta: {
          title: `Package List`,
        },
      },
      {
        path: "/campaign",
        name: "campaign",
        component: () =>
          import(/*webpackChunck: "campaign" */ "../pages/CampaignView.vue"),
        meta: {
          title: `Campaign List`,
        },
      },
      {
        path: "/bannerlist",
        name: "banner",
        component: () =>
          import(/*webpackChunck: "ad banner" */ "../pages/AdbannerView.vue"),
        meta: {
          title: `Banner List`,
        },
      },
      {
        path: "profile",
        name: "profile",
        component: () =>
          import(
            /* webpackChunkName: "profile" */ "../pages/ChangePassword.vue"
          ),
        meta: {
          title: `Profile`,
        },
      },

      {
        path: "/network",
        name: "network",
        component: () =>
          import(/*webpackChunck: "network" */ "../pages/NetworkView.vue"),
        meta: {
          title: `Network List`,
        },
      },
      {
        path: "/server",
        name: "server",
        component: () =>
          import(
            /*webpackChunck: "network" */ "../components/network/NetworkServer.vue"
          ),
        meta: {
          title: `Server`,
        },
      },
      {
        path: "/configuration",
        name: "configuration",
        component: () =>
          import(
            /*webpackChunck: "network" */ "../components/network/NetworkConfiguration.vue"
          ),
        meta: {
          title: `Configuration`,
        },
      },
      {
        path: "/configuration-vpn-server",
        name: "configvpnserver",
        component: () =>
          import(
            /*webpackChunck: "network" */ "../components/network/NetworkConfigVpnServer.vue"
          ),
        meta: {
          title: `Configuration Vpn Server`,
        },
      },
    ],
  },
];

const router = createRouter({
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  document.title = to.meta.title;
  let keepSignedIn = store.state.keepSignedIn.keep_signed_in;
  let auth = store.state.auth.status.loggedIn;
  if (to.meta.middleware === "guest") {
    if (auth) {
      console.log("Dashboard");
      next({ name: "home" });
    }
    next();
  } else {
    if (auth) {
      //check localstorage user data
      let user = JSON.parse(localStorage.getItem("user"));
      if (!user || !user.data.token) {
        keepSignedIn = false;
      }
      if (!keepSignedIn) {
        if (!keepSignedIn && auth) {
          store.dispatch("auth/logout");
          next({ name: "signin", query: { from: to.path } });
        }
      }
      if (to.name == undefined || to.name == "base") {
        next({ name: "home" });
      }
      next();
    } else {
      next({ name: "signin", query: { from: to.path } });
    }
  }
});

export default router;
